import { render, staticRenderFns } from "./yek-poissaolo-view.vue?vue&type=template&id=94b55ce2&scoped=true&"
import script from "./yek-poissaolo-view.vue?vue&type=script&lang=ts&"
export * from "./yek-poissaolo-view.vue?vue&type=script&lang=ts&"
import style0 from "./yek-poissaolo-view.vue?vue&type=style&index=0&id=94b55ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b55ce2",
  null
  
)

export default component.exports